import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DexieService } from "./dexieService";
import { OnlineService } from "./online.service";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpUtils } from "../utils/httpUtils";

@Injectable()
export class BalanceEssayTypeService {

    readonly baseUrl = `${environment.coreUrl}/balanceEssayType`;
    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {
    }

    getAll(): Observable<any> {
        return this.http.get(`${this.baseUrl}/`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}